
import axios, { AxiosResponse } from "axios";
import { Component, Prop, Vue } from "vue-property-decorator";
import GlobalConfig from "@/GlobalConfig";
import WsdlService from "@/services/WsdlService";
import AfiliadoService from "@/services/AfiliadoService";
import Option from "@/models/SelectOption";
import FundTypeObj from "@/models/WsdlResponses/FundTypeObj";
import FundType from "@/models/WsdlResponses/FundType";
import UserBalance from "@/models/WsdlResponses/UserBalance";

@Component({})
export default class ConsultaTuCuentaResult extends Vue {
    @Prop() fromDate: string;
    @Prop() toDate: string;
    @Prop() user: any;
    @Prop() balance: Array<UserBalance>;
    @Prop() initialAmount: number;
    @Prop() finalAmount: number;
    @Prop() movements: any;
    @Prop() comision: any;
    @Prop() comisiones: any;
	@Prop() aportes: any;
	@Prop() initialAMountOldDoceMonth: any;
	@Prop() finalAMountOldDoceMonth: any;


    public oldYear = "";
	public totalAmount: number = 0;
	public initialTotalAmount: string = "";
	public finalTotalAmount: string = "";
	public totalQuotes: number = 0;
    public tiposDeFondos: Array<Option<FundType>> = [];
    public tipoFondo: FundType = new FundType();
    public wsdlService: WsdlService = new WsdlService();
    public afiliadoServices:AfiliadoService = new AfiliadoService();
    public userId: string = this.$store.state.user.cedula;
	public performance: number = 0;
	public performanceAmount: number = 0;

    constructor() {
        
        super();
    }
    public async mounted() {
        await this.getDropdownData();
		await this.getTotalMovements();
		await this.getTotalAmountInRange();
		await this.getPerformance();
		await this.getTransactionPerformance();
    }
	public getTotalAmountInRange()
	{
		this.initialTotalAmount = this.formatNumber(parseFloat((this.initialAmount * Number(this.balance[0].totalcuotas)).toFixed(2)));
		this.finalTotalAmount = this.formatNumber(parseFloat((this.finalAmount * Number(this.balance[1].totalcuotas)).toFixed(2)));
    }
	public getTransactionPerformance(){
		if(!this.totalAmount) return;

		let iniAmount = parseFloat(this.initialTotalAmount.replace(/,/g, ''));
        let finAmount = parseFloat(this.finalTotalAmount.replace(/,/g, ''));
        this.performanceAmount =  (finAmount - iniAmount) - this.totalAmount
		
	}
    public convertirNegativoAPositivo(numero) {
        if (numero < 0) {
            return -numero;
        } else {
            return numero;
        }
    }
    getPerformance() {
    const difference = this.finalAmount - this.finalAMountOldDoceMonth;

    if (this.finalAMountOldDoceMonth !== 0) {
        const operation = (difference / this.finalAMountOldDoceMonth) * 100;
        this.performance = operation;
    } else {
        this.performance = 0;
    }
}

	public async getTotalMovements(){
		if(this.movements && this.movements.length > 0)
		{
			this.movements.forEach(movement => {
				let formattedNumber = movement.movimientosmoneda.replace(',', '');
				
				this.totalAmount += parseFloat(formattedNumber);
				this.totalQuotes += parseFloat(movement.movimientoscuotas);
			});
		}
        
	}

public formatearFecha(fecha) {
  const [dia, mes, año] = fecha.split('/').map(Number);
  const diaFormateado = (dia < 10) ? `0${dia}` : dia;
  const mesFormateado = (mes < 10) ? `0${mes}` : mes;

  return `${mesFormateado}/${diaFormateado}/${año}`;
}
obtenerAnoAnterior(fechaString) {
  var partesFecha = fechaString.split("/");
  var dia = parseInt(partesFecha[0], 10);
  var mes = parseInt(partesFecha[1], 10) - 1; 
  var año = parseInt(partesFecha[2], 10);

  var fecha = new Date(año, mes, dia);

  var añoAnterior = año - 1;

  var nuevaFecha = new Date(añoAnterior, mes, dia);
  var resultado = (
    ("0" + nuevaFecha.getDate()).slice(-2) +
    "/" +
    ("0" + (nuevaFecha.getMonth() + 1)).slice(-2) +
    "/" +
    nuevaFecha.getFullYear()
  );

  return resultado;
}
    async getDropdownData() {
        this.wsdlService
            .getTipoDeFondos(this.userId, "")
            .then((response: AxiosResponse<FundTypeObj>) => {
                let option = new Option<FundType>();
                option.value = response.data.tipofondos;
                option.text = response.data.tipofondos.valor;
                option.disabled = false;
                this.tiposDeFondos.push(option);
                this.tipoFondo = option.value;
                console.log("this.tipoFondogetDropdownData",this.tipoFondo);
            });
    }
	formatNumber(amount: number) : string{
		return (amount).toLocaleString(undefined, { minimumFractionDigits: 2 });
	}
    public returnForm() {
        this.$emit("returnForm");
    }
    public updateUser() {
        this.$router.push("actualizacion-de-datos");
    }
    returnHome() {
        window.location.href = GlobalConfig.PORTAL_BASE_URL
    }
    public formatDate(date: string): string {
        let partitionedDate = date.split("/");
        return `${partitionedDate[1]}/${partitionedDate[0]}/${partitionedDate[2]}`;
    }
}
